import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import Loader from '@/components/ui/Loader';
import { ROUTES } from '@/configs/routes';
import { useLocalStore } from '@/hooks/useLocalStore';
import EmptyNews from '@/pages/EmptyNews';
import { SidebarNewsStore } from '@/stores/local/sidebar/SidebarNewsStore';
import { useDevices } from '@/utils/devices';

const NewsIndex: React.FC = () => {
  const { id } = useParams();
  const { isCompactViewport } = useDevices();
  const store = useLocalStore(() => new SidebarNewsStore({ organizationId: Number(id) }));

  React.useEffect(() => {
    store.init();
  }, [store]);

  if (isCompactViewport) {
    return null;
  }

  if (!store.meta.isStaleLoaded) {
    return <Loader fullHeight type="dots" size="xl" />;
  }

  if (store.collection.items.length > 0) {
    const firstNews = store.collection.items[0];

    return <Navigate to={ROUTES.organization.news.article.create(id as string, String(firstNews.id))} replace />;
  }

  return <EmptyNews />;
};

export default observer(NewsIndex);
